import axios from "axios";
import { nudgeBus } from '@/utils/nudgeBus'
import VueElementLoading from "vue-element-loading";
import CryptoJS from "crypto-js";
import apiUrl from "../../../constants";
import VueJwtDecode from "vue-jwt-decode";

export default {
  name: "InboundMandate",
  components: { VueElementLoading },

  data() {
    return {
      activeMainTab: "Inbound",
      hubId: "",
      hubname: "",
      useremail: "",
      mandates: [],
      isLoading: false,
      showResults: false,
      showPendingModal: false,
      pendingLoading: false,
      pendingBags: [],
      pendingMps: [],
      activeTab: "B2C",
      userMandates: [],
      userLoading: false,
      searchThc: "",
      filteredMandates: [],
      showSuggestions: false,
      selectedThc: "",
      showDeleteModal: false,
      deleteUserInfo: null,
      markingIds: {},
      toasts: [],
      toastIdCounter: 0,
      selectedMandate: null,
      page: 1,
      limit: 15,
      total: 0,
      isCompleteInboundFeatureEnabled: false,
      centerType:'',
      allMandateVehicles: [],
      // FM Bagging
      fmRequestList: [],
      fmShipmentList: [],
      isFMBaggingFeatureEnabled: true,
      fmMarkingIds: {},
      userid:'',
      showFMShipmentModal:false,
      requestId:'',
      activeFMTab: 'bag',
      // Search User Trips
      userTripSearch: '',
      userTripSearched: false,
      userTripProfile: null,
      userTripResults: [],
      userTripStats: { active: 0, inProgress: 0, locked: 0 },
      nudgeMessage: '',
      mandateUserList: [],
      filteredUserList: [],
      showUserSuggestions: false,
      selectedUserTrip: null,
      userTripsLoading: false,
      mandateUserListLoading: false,
      isAuthorizedForRelease: false
    };
  },

  watch: {
  },

  mounted() {
    const userdetailEncrypt = localStorage.getItem("userdetail");
    if (!userdetailEncrypt) return;

    const bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    const plaintext = bytes.toString(CryptoJS.enc.Utf8);
    const userdetail = JSON.parse(plaintext);

    if (!userdetail || !userdetail[0]) return;

    this.useremail = userdetail[0].email;
		this.userid = parseInt(userdetail[0].userid);
    this.hubId = userdetail[0].HubId[0];
    this.fetchMandateList();
    this.getHubName(this.hubId);
    this.fetchUserTripRoleConfig();
    
  },

  methods: {
    getHubName(hubid) {
      this.input = {
        hubids: [hubid]
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
              'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubname = result.data.ResponseData[0].HubName;
            this.centerType = result.data.ResponseData[0].CenterType;
          } else {
            this.hubname = 'hub';
          }
        }, error => {
          console.error(error);
        })
    },
    switchMainTab(tab) {
      this.activeMainTab = tab;

      if (tab === "Inbound") {
        this.selectedMandate = null;
        this.showResults = false;
        this.isLoading = true;
        this.page = 1;
        this.fetchMandateList();
      }

      if (tab === "User") {
        this.selectedMandate = null;
        this.searchThc = "";
        this.userMandates = [];
        this.showSuggestions = false;
        this.filteredMandates = [];
        this.getAllVehicleListForMandate();
      }

      if(tab === 'FMBagging') {
        this.activeFMTab = 'bag';
        this.fmRequestList = [];
        this.fmShortageInitiatedRequests(false);
      }

      if (tab === 'UserTrips') {
        this.userTripSearch = '';
        this.userTripSearched = false;
        this.userTripProfile = null;
        this.userTripResults = [];
        this.userTripStats = { active: 0, inProgress: 0, locked: 0 };
        this.nudgeMessage = '';
        this.filteredUserList = [];
        this.showUserSuggestions = false;
        this.selectedUserTrip = null;
        this.fetchMandateUserList();
      }
    },
getAllVehicleListForMandate() {
  if (!this.hubId) return;

  axios.get(
      `${apiUrl.api_url_hubops}getAllVehicleListForMandate?currentHubId=${this.hubId}`,
      { headers: this.getHeaders() }
    )
    .then(res => {
      if (res.data.ResultCode === 100 && Array.isArray(res.data.ResponseData)) {
        this.allMandateVehicles = res.data.ResponseData;
      } else {
        this.allMandateVehicles = [];
      }
    })
    .catch(err => console.error(err));
},
    fetchMandateList() {
      if (!this.hubId) return;

      this.isLoading = true;

      axios
        .post(
          `${apiUrl.api_url_hubops}inboundTripMandatePendingList`,
          { hubid: this.hubId, page: this.page, limit: this.limit },
          { headers: this.getHeaders() }
        )
        .then(res => {
          if (res.data.ResultCode === 100 && Array.isArray(res.data.data)) {
            this.mandates = res.data.data;
            this.total = res.data.total || 0;
          } else {
            this.mandates = [];
            this.total = 0;
          }
        })
        .catch(err => this.$alertify.error(err.message, "error"))
        .finally(() => {
          this.isLoading = false;
          this.showResults = true;
        });
    },

   filterMandates() {
  if (!this.searchThc.trim()) {
    this.showSuggestions = false;
    this.filteredMandates = [];
    return;
  }

  this.filteredMandates = this.allMandateVehicles.filter(
    m =>
      m.thcno.toString().includes(this.searchThc.trim()) ||
      (m.vehicleno && m.vehicleno.includes(this.searchThc.trim()))
  );

  this.showSuggestions = this.filteredMandates.length > 0;
},
    resetSearch() {
      this.searchThc = "";
      this.filteredMandates = [];
      this.showSuggestions = false;
      this.userMandates = [];
    },

   selectThc(item) {
  const veh = (item.vehicleno || "").trim();
  const thc = (item.thcno || "").toString().trim();

  // populate search input
  this.searchThc = `${veh} (${thc})`;

  this.showSuggestions = false;

  // Fetch user-mapped list for selected trip
  this.fetchUserMandateList(item.tripid || item.thcno);
},

    getHubDetailslist() {
      this.isCompleteInboundFeatureEnabled = false;
      axios({
        method: "GET",
        url: apiUrl.api_url_hubops + "fetchHubTempInscanRestrict?hubid=" + this.hubId,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.isCompleteInboundFeatureEnabled =
              result.data.ResponseData[0].ismandatecompleteinboundflag;
          }
        })
        .catch(error => console.error(error));
    },

    fetchUserMandateList(thcno) {
      if (!thcno) return;

      this.userLoading = true;

      axios
        .post(
          `${apiUrl.api_url_hubops}inboundtripmandateuserlist`,
          { tripid: Number(thcno), isActive: true, hubid: Number(this.hubId) },
          { headers: this.getHeaders() }
        )
        .then(res => {
          this.userMandates = res.data.ResultCode === 100 ? res.data.data : [];
        })
        .catch(err => this.$alertify.error(err.message, "error"))
        .finally(() => {
          this.userLoading = false;
        });
    },

    openPendingModal(mandate) {
      this.selectedMandate = mandate;
      this.showPendingModal = true;
      this.pendingLoading = true;
      this.pendingBags = [];
      this.pendingMps = [];
      this.activeTab = "B2C";

      axios
        .post(
          `${apiUrl.api_url_hubops}getPendingBagsMPSList`,
          {
            ConnectionScheduleMasterId: mandate.connectionschedulemasterid,
            CurrentHubId: this.hubId,
            LastModifiedBy: this.useremail || "system",
            isFromShortagePage : true 
          },
          { headers: this.getHeaders() }
        )
        .then(res => {
          if (res.data.ResultCode === 100) {
            this.pendingBags = res.data.ResponseData.PendingBags || [];
            this.pendingMps = res.data.ResponseData.PendingMPS || [];
          }
        })
        .catch(err => this.$alertify.error(err.message, "error"))
        .finally(() => {
          this.pendingLoading = false;
        });
    },

    closePendingModal() {
      this.showPendingModal = false;
    },

    confirmInbound(mandate) {
      if (!mandate) return;

      const payload = {
        ConnectionScheduleMasterId: mandate.connectionschedulemasterid,
        CurrentHubId: this.hubId,
        LastModifiedBy: this.useremail,
        tripid: Number(mandate.thcno),
      };

      axios
        .post(`${apiUrl.api_url_hubops}completeInbound`, payload, { headers: this.getHeaders() })
        .then(res => {
          if (res.data.ResultCode === 100)
            this.$alertify.success("Inbound completed successfully", "success");
          else this.$alertify.error(res.data.ReturnMessage || "Error completing inbound", "error");
        })
        .catch(err => this.$alertify.error(err.message, "error"));
    },

    markShortage(type, data) {
      const idKey = type === "B2C" ? data.bagno : data.shippingid;
      this.$set(this.markingIds, idKey, true);
      let payload = {},
        api = "";

      if (type === "B2C") {
        api = `${apiUrl.api_url_hubops}markBagShortage`;
        payload = {
          currentHubId: this.hubId,
          lastModifiedBy: this.useremail,
          parentBagNo: data.bagno,
          currentHubName: this.hubname,
          centerType:this.centerType,
          statusMarkedFrom: "WEB"
        };
      } else {
        api = `${apiUrl.api_url_hubops}markShipmentShortage`;
        payload = {
          processLocation: this.hubId,
          shippingId: data.shippingid,
          lastModifiedBy: this.useremail,
          status: data.status,
          shipmentStatus: "OutScan",
          centerType:this.centerType,
        };
      }

      axios
        .post(api, payload, { headers: this.getHeaders() })
        .then(res => {
          if (res.data.ResultCode !== 100) this.$alertify.error(res.data.ReturnMessage || "Already Marked", "error");
          else {
            this.$alertify.success("Marked successfully", "success");
            data.isMarked = true;
          }
          if (res.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: res.data.nudgeMessage, duration: res.data.nudgeDuration }) }
        })
        .catch(err => this.$alertify.error(err.message, "error"))
        .finally(() => {
          this.$set(this.markingIds, idKey, false);
        });
    },

    isBagMarked(bagno) {
      const bag = this.pendingBags.find(b => b.bagno === bagno);
      return bag && bag.isMarked;
    },

    isShipmentMarked(shippingid) {
      const shp = this.pendingMps.find(s => s.shippingid === shippingid);
      return shp && shp.isMarked;
    },

    confirmDelete(user) {
      // when called from UserTrips tab, inject userid from selectedUserTrip
      if (!user.userid && !user.userId && this.selectedUserTrip) {
        user = Object.assign({}, user, { userid: this.selectedUserTrip.userId });
      }
      this.deleteUserInfo = user;
      this.showDeleteModal = true;
    },

    deactivateUser() {
      const deletedUser = this.deleteUserInfo;

      axios
        .post(
          `${apiUrl.api_url_hubops}deleteInboundTripUserByTripId`,
          { tripid: Number(deletedUser.tripid), userid: Number(deletedUser.userid) },
          { headers: this.getHeaders() }
        )
        .then(res => {
          this.userMandates = this.userMandates.map(user => {
            if (user.userid === deletedUser.userid)
              return Object.assign({}, user, { isactive: false });
            return user;
          });

          this.showDeleteModal = false;
          if(res.data.ResultCode === 100){
          this.$alertify.success("User deactivated successfully", "success");
          this.fetchUserMandateList(deletedUser.tripid);
          if (this.activeMainTab === 'UserTrips') { this.fetchUserTaggedTrips(deletedUser.userid); }
          } else {
          this.$alertify.error(res.data.ReturnMessage || "Error deactivating user", "error");
          }
        })
        .catch(err => {
          this.$alertify.error(err.message, "error");
          this.showDeleteModal = false;
        });
    },

    fetchMandateUserList() {
      if (!this.hubId) return;

      this.mandateUserListLoading = true;

      axios
        .post(
          `${apiUrl.api_url_hubops}getMandateUserList`,
          { hubid: Number(this.hubId) },
          { headers: this.getHeaders() }
        )
        .then(res => {
          if (res.data.ResultCode !== 100) {
            this.mandateUserList = [];
            return;
          }
          this.mandateUserList = res.data.data;
        })
        .catch(err => console.error(err))
        .finally(() => {
          this.mandateUserListLoading = false;
        });
    },

    filterUserList() {
      const q = this.userTripSearch.trim().toLowerCase();
      if (!q) {
        this.filteredUserList = [];
        this.showUserSuggestions = false;
        return;
      }

      this.filteredUserList = this.mandateUserList.filter(u => {
        if (!u) return false;
        return (u.userId && u.userId.toString().includes(q)) ||
               (u.email && u.email.toLowerCase().includes(q)) ||
               (u.userName && u.userName.toLowerCase().includes(q));
      });
      this.showUserSuggestions = this.filteredUserList.length > 0;
    },

    selectUserTrip(user) {
      this.userTripSearch = user.userName;
      this.showUserSuggestions = false;
      this.selectedUserTrip = user;
      this.fetchUserTaggedTrips(user.userId);
    },

    searchUserTrips() {
      const q = this.userTripSearch.trim();
      if (!q) {
        this.userTripSearched = true;
        this.userTripProfile = null;
        this.userTripResults = [];
        this.userTripStats = { active: 0, inProgress: 0, locked: 0 };
        return;
      }

      // if user selected from dropdown use that userId, otherwise pass the raw input
      const userId = this.selectedUserTrip ? this.selectedUserTrip.userId : q;
      this.fetchUserTaggedTrips(userId);
    },

    fetchUserTaggedTrips(userId) {
      if (!userId || !this.hubId) return;

      this.userTripsLoading = true;
      this.userTripSearched = false;

      axios
        .get(
          `${apiUrl.api_url_hubops}getUserTaggedTrips?userId=${userId}&hubId=${this.hubId}`,
          { headers: this.getHeaders() }
        )
        .then(res => {
          this.userTripSearched = true;

          if (res.data.ResultCode !== 100) {
            this.userTripProfile = null;
            this.userTripResults = [];
            this.userTripStats = { active: 0, inProgress: 0, locked: 0 };
            this.nudgeMessage = '';
            this.isAuthorizedForRelease = false;
            return;
          }

          // Build profile from selected user (getMandateUserList data)
          const u = this.selectedUserTrip || {};
          const name = (u.userName || '').replace(/\(.*\)/, '').trim();
          const initials = name.split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2);

          this.userTripProfile = {
            name: name,
            email: u.email || '',
            userid: u.userId || userId,
            isActive: true,
            initials: initials || '?',
          };

          const s = res.data.summary || {};
          this.userTripStats = {
            active: s.activeTrips || 0,
            inProgress: s.inProgress || 0,
            locked: s.locked || 0,
          };

          this.nudgeMessage = res.data.nudgeMessage || '';

          var rawData = Array.isArray(res.data.data) ? res.data.data : [];

          this.userTripResults = rawData
            .filter(function (t) { return t; })
            .map(function (t) {
              return Object.assign({}, t, {
                startTime: t.inboundStartTime || '-'
              });
            });

          // --- Authorization: fetch config and check release roles ---
          return this.fetchUserTripRoleConfig();
          // ------------------------------------------------------------------
        })
        .catch(err => {
          this.userTripSearched = true;
          this.$alertify.error(err.message, 'error');
        })
        .finally(() => {
          this.userTripsLoading = false;
        });
    },

    fetchUserTripRoleConfig() {
      return axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'getVehicleSealConfiguration?hubid=' + this.hubId,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.isCompleteInboundFeatureEnabled = result.data.ismandatecompleteinboundflag;            
            let accessToken = window.localStorage.getItem('access_token');
            let roles = VueJwtDecode.decode(accessToken);
            roles = roles.resource_access;
            roles = roles["hubops-service"];
            roles = roles.roles;
            let userroles = roles.map(item => item.toLowerCase());
            
            let releaseRoles = result.data.config && result.data.config.release_roles
              ? result.data.config.release_roles
              : (result.data.config && result.data.config.ci_web_roles ? result.data.config.ci_web_roles : []);
            const releaseRolesLower = releaseRoles.map(item => item ? item.toLowerCase() : '');
            this.isAuthorizedForRelease = releaseRolesLower.length > 0
              ? releaseRolesLower.some(value => userroles.includes(value))
              : false;

          } else {
            this.isAuthorizedForRelease = false;
          }
        })
        .catch(err => {
          console.error('Role config fetch error:', err);
          this.isAuthorizedForRelease = false;
        });
    },

    resetUserTripSearch() {
      this.userTripSearch = '';
      this.userTripSearched = false;
      this.userTripProfile = null;
      this.userTripResults = [];
      this.userTripStats = { active: 0, inProgress: 0, locked: 0 };
      this.nudgeMessage = '';
      this.filteredUserList = [];
      this.showUserSuggestions = false;
      this.selectedUserTrip = null;
      this.userTripsLoading = false;
      this.mandateUserListLoading = false;
      this.isAuthorizedForRelease = false;
    },

    getHeaders() {
      return {
        "Content-Type": "application/json",
        Authorization: "authkey xB84JJ89Hd25",
        token: localStorage.getItem("token") || "",
      };
    },

    // FM Bagging
    fmShortageInitiatedRequests(isShipmentShortage) {
      this.isLoading = true;
      this.fmRequestList = [];

      axios.get(`${apiUrl.api_url_hubops}fmBagging/getShortageInitatedRequests?hubId=${this.hubId}&isShipmentShortage=${isShipmentShortage}`,
          { headers: this.getHeaders() }
      ).then(res => {
        if (res.data.ResultCode == 100) {
          this.fmRequestList = res.data.ResponseData.shortageRequests;
          this.$alertify.success(res.data.ReturnMessage);
        }else {
          this.$alertify.error(res.data.ReturnMessage, "error")
        }

        this.isLoading = false;
      }).catch(err => this.$alertify.error(err.message, "error")).finally(() => {
        this.isLoading = false;
      });
    },

    markFMShortage(data) {
      // this.$set(this.fmMarkingIds, data.shippingid, true);

      let payload = {
        hubId: this.hubId,
        userId: this.userid,
        requestId: this.requestId,
        isSupervisor: true,
        eventName: "ShortageApprovedByExecutive"
      };

      this.pendingLoading = true;

      axios.post(`${apiUrl.api_url_hubops}fmBagging/approveShortageRequest`, 
        payload, 
        { headers: this.getHeaders() }
      ).then(res => {
        if (res.data.ResultCode !== 100) this.$alertify.error(res.data.ReturnMessage || "Already Approved", "error");
        else {
          this.$alertify.success(res.data.ReturnMessage, "success");
          if(this.activeFMTab == 'bag'){
            this.fmShortageInitiatedRequests(false);
          }else if(this.activeFMTab == 'shipment'){
            this.fmShortageInitiatedRequests(false);
          }
          // data.isMarked = true;
        }
        this.pendingLoading = false;
      }).catch(err => this.$alertify.error(err.message, "error"), this.pendingLoading = false)
      .finally(() => {
        // this.$set(this.fmMarkingIds, data.shippingid, false);
        this.pendingLoading = false;
      });
    },

    isfmMarked(shippingid) {
      let fmShip = this.fmShipmentList.find(b => b.shippingid == shippingid);
      return fmShip && fmShip.isMarked;
    },

    openFMShipmentModal(shipmentIds, requestId) {
      this.showFMShipmentModal = true;

      this.fmShipmentList = shipmentIds;
      this.requestId = requestId;
    }
  },
};



// WEBPACK FOOTER //
// ./src/views/components/InboundMandate/InboundMandate.js